function DeleteConfirmationController($scope, $uibModalInstance, message) {
  $scope.message = message;

  $scope.close = () => {
    $uibModalInstance.dismiss();
  };

  $scope.delete = () => {
    $uibModalInstance.close();
  };
}

const delConfCtrlArray = [
  '$scope',
  '$uibModalInstance',
  'message',
  DeleteConfirmationController
];

module.exports = (ngModule) => {
  ngModule.controller('DeleteConfirmationController', delConfCtrlArray);
};
